import React from 'react';
import PropTypes from 'prop-types';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

function ScoreLineChart({ data, minScore, maxScore, graphWidth }) {
  return (
    <LineChart
      width={graphWidth}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis
        yAxisId="left"
        domain={[
          Math.floor(Math.max(minScore - 10, 0) / 10) * 10,
          Math.ceil(Math.min(maxScore + 10, 100) / 10) * 10,
        ]}
      />
      {/* <YAxis yAxisId="right" orientation="right" /> */}
      <Tooltip />
      <Legend />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="overall"
        stroke="#d32f2f"
        strokeWidth="4px"
        activeDot={{ r: 8 }}
      />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="ideas"
        stroke="#673ab7"
        strokeWidth="2px"
      />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="organization"
        stroke="#82ca9d"
        strokeWidth="2px"
      />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="language"
        stroke="#3f51b5"
        strokeWidth="2px"
      />
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="grammar"
        stroke="#ff9800"
        strokeWidth="2px"
      />
      {/* <Line yAxisId="left" type="monotone" dataKey="amt" stroke="#82ca9d" /> */}
    </LineChart>
  );
}

ScoreLineChart.propTypes = {
  data: PropTypes.arrayOf(Object),
  minScore: PropTypes.number,
  maxScore: PropTypes.number,
  graphWidth: PropTypes.number.isRequired,
};

export default ScoreLineChart;
